import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { ProgressBar, Tab, Tabs } from 'react-bootstrap';

import TermPredictions from '../TermPredictions';
import s from './GeneDetail.css';

/*
 * Component that displays detailed information about a gene. For example,
 * predicted biological processes, tissue expression, and disease
 */

const GeneDetail = ({ gene, termPredictions, termDatabases }) => {
  // Show a tab for each term database. If there are no predictions, show a
  // spinner, otherwise show the predictions
  const tabs = (db, idx) => {
    if (!termPredictions || !termPredictions[db.slug])
      return (
        <Tab
          key={idx}
          eventKey={idx + 1}
          title={
            <div>
              <i className="fa fa-refresh fa-spin" /> {db.name}
            </div>
          }
        />
      );
    return (
      <Tab eventKey={idx + 1} title={db.name} key={idx}>
        <TermPredictions
          key={idx}
          width={570}
          genes={[gene]}
          allPredictions={{ [gene.entrez]: termPredictions[db.slug] }}
        />
      </Tab>
    );
  };

  const xrefs = (obj, idx) => (
    <li key={idx}>
      <a
        href={obj.crossrefdb.url.replace('_REPL_', obj.xrid)}
        rel="noreferrer"
        target="_blank"
      >
        {obj.crossrefdb.name}: {obj.xrid}
      </a>
    </li>
  );

  const aliases = (obj, idx) => <li key={idx}>{obj} </li>;

  return (
    <div className={s.root}>
      <dl className="dl-horizontal">
        <dt />
        <dd>
          <ul className="list-inline">
            <h2>
              {gene.standard_name}
              <br />
              <small>{gene.description}</small>
            </h2>
          </ul>
        </dd>
        <dt>Also known as</dt>
        <dd>
          <ul className="list-inline">{gene.aliases.map(aliases)}</ul>
        </dd>
        <dt>Gene IDs</dt>
        <dd>
          <ul className="list-inline">{gene.xrefs.map(xrefs)}</ul>
        </dd>
      </dl>
      <Tabs
        className="tab-under"
        id="gene-detail"
        defaultActiveKey={1}
        bsStyle="pills"
      >
        {termDatabases ? (
          termDatabases.map(tabs)
        ) : (
          <ProgressBar
            active
            striped
            label="Retrieving gene detail"
            now={100}
          />
        )}
      </Tabs>
    </div>
  );
};

GeneDetail.propTypes = {
  // Gene to show detail on
  gene: PropTypes.shape({
    entrez: PropTypes.number,
    standard_name: PropTypes.string,
    description: PropTypes.string,
    aliases: PropTypes.arrayOf(PropTypes.string),
    xrefs: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,

  // Terms predicted for the gene
  termPredictions: PropTypes.shape({
    slug: PropTypes.arrayOf(PropTypes.object),
  }),

  // The term databases to draw terms from
  termDatabases: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withStyles(s)(GeneDetail);
